module.exports = __webpack_public_path__ + "09_face.573757ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/09_face.png
// module id = 4CcX
// module chunks = 0